import { useMemo } from 'react';

import { MyUntargetedUsersQuery } from '../../apollo/__generated__/graphql';

export const useUserCard = (
  user: MyUntargetedUsersQuery['myUntargetedUsers'][number],
  currentImageIndex: number,
) => {
  const currentImage = useMemo(
    () => user.images[currentImageIndex],
    [user.images, currentImageIndex],
  );

  return {
    currentImage,
  };
};
